import { render, staticRenderFns } from "./choosegroup.vue?vue&type=template&id=36f607e2&scoped=true&"
import script from "./choosegroup.vue?vue&type=script&lang=js&"
export * from "./choosegroup.vue?vue&type=script&lang=js&"
import style0 from "./choosegroup.vue?vue&type=style&index=0&id=36f607e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f607e2",
  null
  
)

export default component.exports